"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyServiceAxiosRepository = void 0;
class ProxyServiceAxiosRepository {
    constructor(httpService) {
        this.httpService = httpService;
    }
    getAlive() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.httpService
                .get("inquiry/alive")
                .then((response) => response.data)
                .catch((error) => {
                throw error;
            });
        });
    }
    getInquiryLocalize(ip) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.httpService
                .post("inquiry/localize", { ipAddress: ip })
                .then((response) => response.data)
                .catch((error) => {
                throw error;
            });
        });
    }
    getUserIp() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.httpService
                .get("inquiry/get-remote-ip")
                .then((response) => response.data.ip)
                .catch((error) => {
                throw error;
            });
        });
    }
    getOrdersByDate(ordersByDateArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            const { fromDate, toDate, customerId, storeCode, currentPage, pageSize } = ordersByDateArgs;
            return yield this.httpService
                .get(`order-by-date?from=${fromDate}&to=${toDate}&customerId=${customerId}&store=${storeCode}&currentPage=${currentPage}&pageSize=${pageSize}`)
                .then((response) => response.status == 200 ? response.data : null)
                .catch((error) => {
                throw error;
            });
        });
    }
    getOrders(ordersArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.httpService
                .get(`orders?customerId=${ordersArgs.customerId}&store=${ordersArgs.storeCode}`)
                .then((response) => response.status == 200 ? response.data : null)
                .catch((error) => {
                throw error;
            });
        });
    }
    getOrder(orderArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.httpService
                .get(`order-by-id?orderId=${orderArgs.orderId}&customerId=${orderArgs.customerId}&store=${orderArgs.storeCode}`)
                .then((response) => response.status == 200 ? response.data : null)
                .catch((error) => {
                throw error;
            });
        });
    }
    getInvoicesByOrderId(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.httpService
                .get(`invoices-by-order-id?orderId=${orderId}`)
                .then((response) => response.status == 200 ? response.data : null)
                .catch((error) => {
                throw error;
            });
        });
    }
    getProductImage(productImageBySkuArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.httpService
                .get(`image/${productImageBySkuArgs.storeCode}/${productImageBySkuArgs.sku}${productImageBySkuArgs.base64 ? "?base64=true" : ""}`)
                .then((response) => response.status == 200 ? response.data : null)
                .catch((error) => {
                throw error;
            });
        });
    }
    getCartQuote(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.httpService
                .get(`/get-cart-quote/${cartId}`)
                .then((response) => response.status == 200 ? response.data : null)
                .catch((error) => {
                throw error;
            });
        });
    }
    getOrdersById(ordersByIdArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            const { orderId, customerId, storeCode, currentPage, pageSize } = ordersByIdArgs;
            return yield this.httpService
                .get(`/order-by-command-number?commandNumber=${orderId}&customerId=${customerId}&store=${storeCode}&currentPage=${currentPage}&pageSize=${pageSize}`)
                .then((response) => {
                return response.status == 200 ? response.data : null;
            })
                .catch((error) => {
                throw error;
            });
        });
    }
    getShippingStatus(orderStatusArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.httpService
                .get(`order-status?email=${orderStatusArgs.email}&order_id=${orderStatusArgs.orderId}&store=${orderStatusArgs.currentStore}`)
                .then((response) => {
                return response.status == 200 ? response.data : null;
            })
                .catch((error) => {
                throw error;
            });
        });
    }
}
exports.ProxyServiceAxiosRepository = ProxyServiceAxiosRepository;
//# sourceMappingURL=proxyServiceAxiosRepository.js.map